export const cleanPhoneNumber = (phone: string) => {
  return phone.replace(/[\s\\(\\)\\-]/g, '').substring(1);
};
